import type { Traducao } from '../tipos';

/**
 * Vocabulário que aparece em quase toda tela — ação de formulário, estado de
 * carregamento, rótulo de coluna genérico. Só entra aqui o que é usado por
 * mais de uma área; texto de uma tela só mora no dicionário dela.
 */
export const comum: Traducao = {
  pt: {
    acao: {
      salvar: 'Salvar',
      salvando: 'Salvando...',
      cancelar: 'Cancelar',
      excluir: 'Excluir',
      remover: 'Remover',
      editar: 'Editar',
      criar: 'Criar',
      adicionar: 'Adicionar',
      duplicar: 'Duplicar',
      fechar: 'Fechar',
      voltar: 'Voltar',
      avancar: 'Avançar',
      confirmar: 'Confirmar',
      buscar: 'Buscar',
      filtrar: 'Filtrar',
      limpar: 'Limpar',
      atualizar: 'Atualizar',
      baixar: 'Baixar',
      exportar: 'Exportar',
      importar: 'Importar',
      enviar: 'Enviar',
      abrir: 'Abrir',
      visualizar: 'Visualizar',
      selecionar: 'Selecionar',
      selecioneOpcao: 'Selecione...',
      verTodos: 'Ver todos',
      tentarNovamente: 'Tentar novamente',
      copiar: 'Copiar',
      imprimir: 'Imprimir',
    },
    estado: {
      carregando: 'Carregando...',
      salvo: 'Salvo',
      semDados: 'Nenhum dado encontrado',
      semResultados: 'Nenhum resultado para a busca',
      erro: 'Ocorreu um erro',
      erroCarregar: 'Não foi possível carregar os dados',
      ativo: 'Ativo',
      inativo: 'Inativo',
      arquivado: 'Arquivado',
      obrigatorio: 'Campo obrigatório',
      opcional: 'opcional',
    },
    rotulo: {
      nome: 'Nome',
      descricao: 'Descrição',
      tipo: 'Tipo',
      status: 'Status',
      acoes: 'Ações',
      area: 'Área',
      local: 'Local',
      empresa: 'Empresa',
      observacoes: 'Observações',
      data: 'Data',
      periodo: 'Período',
      responsavel: 'Responsável',
      total: 'Total',
      todos: 'Todos',
      todas: 'Todas',
      sim: 'Sim',
      nao: 'Não',
      pesquisar: 'Pesquisar...',
      semanaAbrev: 'Sem.',
      semana: 'Semana',
      de: 'de',
      ate: 'até',
    },
    confirmacao: {
      titulo: 'Confirmar',
      excluirRegistro: 'Tem certeza que deseja excluir este registro?',
      acaoIrreversivel: 'Esta ação não pode ser desfeita.',
    },
    arquivo: {
      nenhumEscolhido: 'Nenhum arquivo escolhido',
      cliqueUpload: 'Clique para fazer upload',
      arrasteSolte: 'Arraste e solte o arquivo aqui',
    },
  },
  en: {
    acao: {
      salvar: 'Save',
      salvando: 'Saving...',
      cancelar: 'Cancel',
      excluir: 'Delete',
      remover: 'Remove',
      editar: 'Edit',
      criar: 'Create',
      adicionar: 'Add',
      duplicar: 'Duplicate',
      fechar: 'Close',
      voltar: 'Back',
      avancar: 'Next',
      confirmar: 'Confirm',
      buscar: 'Search',
      filtrar: 'Filter',
      limpar: 'Clear',
      atualizar: 'Refresh',
      baixar: 'Download',
      exportar: 'Export',
      importar: 'Import',
      enviar: 'Submit',
      abrir: 'Open',
      visualizar: 'View',
      selecionar: 'Select',
      selecioneOpcao: 'Select...',
      verTodos: 'View all',
      tentarNovamente: 'Try again',
      copiar: 'Copy',
      imprimir: 'Print',
    },
    estado: {
      carregando: 'Loading...',
      salvo: 'Saved',
      semDados: 'No data found',
      semResultados: 'No results for this search',
      erro: 'Something went wrong',
      erroCarregar: 'Could not load the data',
      ativo: 'Active',
      inativo: 'Inactive',
      arquivado: 'Archived',
      obrigatorio: 'Required field',
      opcional: 'optional',
    },
    rotulo: {
      nome: 'Name',
      descricao: 'Description',
      tipo: 'Type',
      status: 'Status',
      acoes: 'Actions',
      area: 'Area',
      local: 'Location',
      empresa: 'Company',
      observacoes: 'Notes',
      data: 'Date',
      periodo: 'Period',
      responsavel: 'Owner',
      total: 'Total',
      todos: 'All',
      todas: 'All',
      sim: 'Yes',
      nao: 'No',
      pesquisar: 'Search...',
      semanaAbrev: 'Wk',
      semana: 'Week',
      de: 'of',
      ate: 'to',
    },
    confirmacao: {
      titulo: 'Confirm',
      excluirRegistro: 'Are you sure you want to delete this record?',
      acaoIrreversivel: 'This action cannot be undone.',
    },
    arquivo: {
      nenhumEscolhido: 'No file selected',
      cliqueUpload: 'Click to upload',
      arrasteSolte: 'Drag and drop the file here',
    },
  },
};
